import { DOCUMENT } from "@angular/common";
import { inject, Injectable } from "@angular/core";
import { SupportChatProvider } from "./support-chat-provider";

declare global {
    interface Window {
        AsaFlow?: { chat?: { open?: () => void; close?: () => void } };
    }
}

// Styled in styles.scss: the widget has no hide or remove API, so hiding it is a CSS class on <body> (VS-1960).
export const ASAFLOW_HIDDEN_CLASS = "support-chat-hidden";

@Injectable({
    providedIn: "root",
})
export class AsaflowChatProvider implements SupportChatProvider {
    private _document = inject(DOCUMENT);

    load() {
        const script = this._document.createElement("script");
        script.src = "https://app.asaflow.com.br/widget.js";
        script.async = true;
        script.setAttribute("data-asaflow-chat-key", "d459ad353e9377c0a96b412ccfd00cc24887");
        script.setAttribute("data-asaflow-chat-api", "https://app.asaflow.com.br");
        this._document.head.appendChild(script);
    }

    setVisible(visible: boolean) {
        this._document.body.classList.toggle(ASAFLOW_HIDDEN_CLASS, !visible);
        if (!visible) {
            window.AsaFlow?.chat?.close?.();
        }
    }

    open() {
        window.AsaFlow?.chat?.open?.();
    }
}
